import { useState } from "react";
import CopyCode from "../../CopyCode/CopyCode";
import Icon from "../../Icon";

const Breadcrumbs = () => {
  return (
    <div className="flex flex-col gap-y-10 p-6">
      {/* BASIC BREADCRUMBS */}
      <div className="bg-slate-800 border border-slate-700 rounded-xl p-6 space-y-4">
        <h2 className="text-xl font-bold text-white mb-6">Basic Breadcrumbs</h2>
        <div className="grid grid-cols-1 gap-4">
          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Simple Breadcrumb</label>
            <div className="text-sm text-slate-400">
              Home / Products / Electronics
            </div>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<div className="text-sm text-slate-400">
  Home / Products / Electronics
</div>`} />
          </div>

          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg">
            <label className="text-xs text-slate-400 mb-3 block font-medium">With Links</label>
            <div className="text-sm">
              <a href="#" className="text-amber-400 hover:text-amber-300">Home</a>
              <span className="text-slate-600 mx-1">/</span>
              <a href="#" className="text-amber-400 hover:text-amber-300">Products</a>
              <span className="text-slate-600 mx-1">/</span>
              <span className="text-slate-400">Laptops</span>
            </div>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<a href="#" className="text-amber-400 hover:text-amber-300">Home</a>
<span className="text-slate-600">/</span>
<a href="#" className="text-amber-400">Products</a>
<span className="text-slate-600">/</span>
<span className="text-slate-400">Current</span>`} />
          </div>

          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg">
            <label className="text-xs text-slate-400 mb-3 block font-medium">With Icons</label>
            <div className="text-sm flex items-center gap-1">
              <span><Icon name="home" className="w-4 h-4" /></span>
              <a href="#" className="text-amber-400">Home</a>
              <span className="text-slate-600"><Icon name="arrowRight" className="w-3 h-3" /></span>
              <span><Icon name="fileText" className="w-4 h-4" /></span>
              <a href="#" className="text-amber-400">Docs</a>
              <span className="text-slate-600"><Icon name="arrowRight" className="w-3 h-3" /></span>
              <span></span>
              <span className="text-slate-400">Getting Started</span>
            </div>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<div className="flex items-center gap-1">
  <span>Icon</span>
  <a href="#">Home</a>
  <span>></span>
  <span>Icon</span>
  <a href="#">Docs</a>
</div>`} />
          </div>

          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Chevron Separator</label>
            <div className="text-sm flex items-center gap-2">
              <a href="#" className="text-amber-400 hover:text-amber-300">Dashboard</a>
              <span className="text-slate-500"><Icon name="arrowRight" className="w-3 h-3" /></span>
              <a href="#" className="text-amber-400 hover:text-amber-300">Settings</a>
              <span className="text-slate-500"><Icon name="arrowRight" className="w-3 h-3" /></span>
              <span className="text-slate-400">Profile</span>
            </div>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<a href="#" className="text-amber-400">Dashboard</a>
<span className="text-slate-500">&gt;</span>
<a href="#" className="text-amber-400">Settings</a>
<span className="text-slate-500">&gt;</span>
<span>Profile</span>`} />
          </div>

          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Arrow Separator</label>
            <div className="text-sm flex items-center gap-2">
              <a href="#" className="text-amber-400">Products</a>
              <span className="text-slate-600"><Icon name="arrowRight" className="w-3 h-3" /></span>
              <a href="#" className="text-amber-400">Categories</a>
              <span className="text-slate-600"><Icon name="arrowRight" className="w-3 h-3" /></span>
              <span className="text-slate-400">Electronics</span>
            </div>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<a href="#" className="text-amber-400">Products</a>
<span className="text-slate-600"></span>
<a href="#" className="text-amber-400">Categories</a>
<span>Current</span>`} />
          </div>

          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg">
            <label className="text-xs text-slate-400 mb-3 block font-medium">With Dropdown</label>
            <div className="text-sm flex items-center gap-2">
              <span className="text-amber-400 cursor-pointer">Admin </span>
              <span className="text-slate-600"><Icon name="chevronDown" className="w-3 h-3" /></span>
              <a href="#" className="text-amber-400">Users</a>
              <span className="text-slate-600">/</span>
              <span className="text-slate-400">Edit</span>
            </div>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<span className="text-amber-400">Admin </span>
<span className="text-slate-600">/</span>
<a href="#">Users</a>
<span className="text-slate-400">Edit</span>`} />
          </div>
        </div>
      </div>

      {/* STYLED BREADCRUMBS */}
      <div className="bg-slate-800 border border-slate-700 rounded-xl p-6 space-y-4">
        <h2 className="text-xl font-bold text-amber-400 mb-6">Styled Breadcrumbs</h2>
        <div className="grid grid-cols-1 gap-4">
          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Pill Style</label>
            <div className="text-sm flex items-center gap-1">
              <span className="px-2 py-1 rounded-full bg-amber-900 text-amber-300">Home</span>
              <span className="text-slate-600">/</span>
              <span className="px-2 py-1 rounded-full bg-slate-700 text-slate-300">Products</span>
              <span className="text-slate-600">/</span>
              <span className="px-2 py-1 rounded-full bg-slate-600 text-slate-200">Current</span>
            </div>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<span className="px-2 py-1 rounded-full bg-amber-900">Home</span>
<span className="text-slate-600">/</span>
<span className="rounded-full bg-slate-700">Products</span>`} />
          </div>

          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Bordered Style</label>
            <div className="text-sm flex items-center gap-2">
              <a href="#" className="px-3 py-1 border border-amber-600 rounded text-amber-400">Home</a>
              <span><Icon name="arrowRight" className="w-3 h-3" /></span>
              <a href="#" className="px-3 py-1 border border-slate-600 rounded text-slate-400">Page</a>
              <span><Icon name="arrowRight" className="w-3 h-3" /></span>
              <span className="px-3 py-1 border border-slate-500 rounded text-slate-300">Current</span>
            </div>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<a href="#" className="px-3 py-1 border border-amber-600">Home</a>
<span></span>
<span className="px-3 py-1 border">Current</span>`} />
          </div>

          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Compact Breadcrumb</label>
            <div className="text-xs flex items-center gap-1">
              <a href="#" className="text-amber-400 hover:underline">A</a>
              <span className="text-slate-600"><Icon name="arrowRight" className="w-3 h-3" /></span>
              <a href="#" className="text-amber-400 hover:underline">B</a>
              <span className="text-slate-600"><Icon name="arrowRight" className="w-3 h-3" /></span>
              <a href="#" className="text-amber-400 hover:underline">C</a>
              <span className="text-slate-600">/</span>
              <span className="text-slate-400">D</span>
            </div>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<div className="text-xs flex gap-1">
  <a href="#">A</a>
  <span>/</span>
  <a href="#">B</a>
  <span>/</span>
  <span>Current</span>
</div>`} />
          </div>

          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Shadow Breadcrumb</label>
            <div className="text-sm flex items-center gap-2 p-2 bg-slate-800 rounded-lg shadow-md">
              <a href="#" className="text-amber-400">Admin</a>
              <span className="text-slate-600">/</span>
              <a href="#" className="text-amber-400">Users</a>
              <span className="text-slate-600">/</span>
              <span className="text-slate-400">Profile</span>
            </div>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<div className="p-2 bg-slate-800 rounded-lg shadow-md">
  <a href="#">Admin</a>
  <span>/</span>
  <a href="#">Users</a>
</div>`} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Breadcrumbs;


